import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
    paymentCardLoadSucceeded,
    paymentInvoiceLoadSucceeded,
    paymentLoad,
    paymentLoadFailed, paymentStart
} from './payment.actions';
import { catchError, map, mergeMap, switchMap, tap } from 'rxjs/operators';
import { InvoiceService } from '../../data/invoice.service';
import { LocaleService } from '../../modules/shared/services/locale.service';
import { of } from 'rxjs';
import { CreditCardService } from '../../data/credit-card.service';
import { MakePaymentComponent } from '../../modules/payment/make-payment/make-payment.component';
import { MatDialog } from '@angular/material/dialog';

@Injectable()
export class PaymentEffects {

    constructor(private actions$: Actions, private invoiceService: InvoiceService, private creditCardService: CreditCardService,
                private localeService: LocaleService, private dialog: MatDialog) {
    }

    paymentStart$ = createEffect(() => this.actions$.pipe(
        ofType(paymentStart),
        tap(() => this.dialog.open(MakePaymentComponent)),
        map(() => paymentLoad())
    ));

    paymentInvoiceLoad$ = createEffect(() => this.actions$.pipe(
        ofType(paymentLoad),
        switchMap(() => this.invoiceService.payable().pipe(
            map(invoices => paymentInvoiceLoadSucceeded({ invoices }))
        )),
        catchError(e => of(paymentLoadFailed({ message: this.localeService.createServerMessage(e.message) })))
    ));

    paymentCardLoad$ = createEffect(() => this.actions$.pipe(
        ofType(paymentLoad),
        switchMap(() => this.creditCardService.all().pipe(
            map(result => paymentCardLoadSucceeded({ creditCards: result.page })),
        )),
        catchError(e => of(paymentLoadFailed({ message: this.localeService.createServerMessage(e.message) })))
    ));

}
